import React from 'react';

class LoadingSpinner extends React.Component {
    render() {
        const classes = this.props.overlay ? "loadOverlay" : "loading loading-spinner";
        const style = {
            display: "block"
        };
        
        return (
            <div className={classes} style={style}>
                <svg className="fas fa-spinner fa-spin" width={this.props.size} height={this.props.size}>
                    <use xlinkHref="/assets/img/peters-spinner.svg#petersSpinner"></use>
                </svg>
                <div className="loading-text">{this.props.text}</div>
            </div>
        );
    }
}
 
export default LoadingSpinner;